<template>
  <div class="container_floating_calendar">
    <div class="d-flex justify-start floating_calendar_cards sm-gap">
      <div v-for="(day, index_day) in list_days_in_event" :key="index_day" class="calendar_card rounded bg-dark">
        <div class="text-body-1">{{ $moment(day).format("DD") }}</div>
        <div class="text-body-2 text-primary font-weight-bold">
          {{ $moment(day).format("MMM") }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["debut", "fin"],
  computed: {
    // Liste des jours compris dans la durée de l'évenement
    list_days_in_event() {
      let days = [];
      var date_debut = this.$moment(this.debut);
      var date_fin = this.$moment(this.fin);
      let start_day = this.$moment(date_debut);
      days.push(start_day);
      while (date_debut.isBefore(date_fin)) {
        let new_day = this.$moment(date_debut.add(1, "d"));
        days.push(new_day);
      }
      if (days.length > 3) {
        return [days[0], days[days.length - 1]];
      }
      return days;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>